import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericFilter } from '../models/GenericFilter';
import { CheckForGroupRoleUsers, GroupRolePermissionDto, GroupRolePermissionForCreation } from '../models/GroupRole';
import { BaseService } from './base.service';

@Injectable({ providedIn: 'root' })
export class GroupRolePermissionService extends BaseService {
  

  constructor(private httpClient: HttpClient) {
    super();
  }

  loadGroupRolePermissions(roleId: string) : Observable<GroupRolePermissionDto[]> {
    return this.httpClient.get<GroupRolePermissionDto[]>(`${this.groupRolePermissions}/${roleId}`);
  }

  getGroupRolePermissions(roleId: string, permissionId: string): Observable<GroupRolePermissionDto[]> {
    return this.httpClient.get<GroupRolePermissionDto[]>(`${this.groupRolePermissions}/${roleId}/GetGroupRolePermissions/${permissionId}`);
  }

  // checkForGroupRoleUsers(roleId: any, projectId:string) :Observable<any> {
  //   return this.httpClient.get<any>(`${this.groupRolePermissions}/${roleId}/CheckIfThereGroupRoleUsers/${projectId}`);
  // }

  loadGroupRolePermission(genericFilter: GenericFilter): Observable<GroupRolePermissionDto[]> {
    return this.httpClient.post<GroupRolePermissionDto[]>(`${this.groupRolePermissions}/GetFilteredGroupRolePermissions`, genericFilter);
  }

  createGroupRolePermission(grpRolePermission: GroupRolePermissionForCreation): Observable<GroupRolePermissionForCreation> {
    return this.httpClient.post<GroupRolePermissionForCreation>(`${this.groupRolePermissions}`, grpRolePermission);
  }

  updateGroupRolePermission(groupRolePermission: GroupRolePermissionDto) : Observable<GroupRolePermissionDto> {
    return this.httpClient.put<GroupRolePermissionDto>(`${this.groupRolePermissions}`, groupRolePermission);
  }

  deleteGroupRolePermission(id: string): Observable<any> {
    return this.httpClient.delete<any>(`${this.groupRolePermissions}/${id}/DeleteProjectGroupRolePermission`);
  }
}
